export default __webpack_public_path__ + "static/media/Theme13.9b7e0768.png";